import { render, staticRenderFns } from "./serverOptions.vue?vue&type=template&id=3bc3845d&scoped=true&"
import script from "./serverOptions.vue?vue&type=script&lang=js&"
export * from "./serverOptions.vue?vue&type=script&lang=js&"
import style0 from "./serverOptions.vue?vue&type=style&index=0&id=3bc3845d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc3845d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc3845d')) {
      api.createRecord('3bc3845d', component.options)
    } else {
      api.reload('3bc3845d', component.options)
    }
    module.hot.accept("./serverOptions.vue?vue&type=template&id=3bc3845d&scoped=true&", function () {
      api.rerender('3bc3845d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/serverOptions.vue"
export default component.exports